// @flow
import React from 'react';

import { COLORS } from 'Components/utils/color/colors';

import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

import {
  ProductFeatureDetailInformation,
  type ProductFeatureDetailInformationProps,
} from './ProductFeatureDetailInformation.jsx';

type Props = {
  className?: string,
  color?: Colors,
  items: Array<ProductFeatureDetailInformationProps>,
  notes?: string,
  title?: string,
};

export function ProductFeatureDetailInformations(props: Props) {
  const { className, color = COLORS.GRAY_DARKER, items = [], notes, title = '' } = props;

  if (!items.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title className="mb-5" color={color} hLevel={3} theme="title-brand-4">
        {title}
      </Title>
      <ul className="sm:colum-count-2 list-none p-0 m-0">
        {items.map((item, idx) => {
          return item && item.description ? (
            <li
              className={`break-inside-avoid-column list-disc my-3${idx === 0 ? ' mt-0' : ''}`}
              key={item.description}
            >
              <ProductFeatureDetailInformation {...item} />
            </li>
          ) : null;
        })}
      </ul>
      {!!notes && (
        <Text className="mt-3" color={COLORS.GRAY_DARKER} text={notes} theme="text-sans-2" />
      )}
    </section>
  );
}
